import React from 'react';
import { Routes, Route } from "react-router-dom";
import Home from './components/Home';
// import CoreServices from './components/CoreServices';
import ScrollToTop from './components/ScrollToTop';
import PrivacyPolicy from './components/PrivacyPolicy'
import TermsOfUse from './components/TermsOfUse';
import { Helmet } from 'react-helmet';
// import NotFound from "./components/NotFound";

function App() {

  return (
    <div>
      <Helmet>
          <title>Kaizek - Engineering the future of Connected Devices</title>
          <meta name="Kaizek - EMBEDDED SYSTEMS & IoT EXPERTS"
          keywords="ideation, strategy, product, ai, machine learning, data science"
          content="Specializing in custom firmware, embedded software development, and IoT solutions." />
      </Helmet>
      {
        <ScrollToTop/>
      }
      
        <Routes>
          <Route path='/' element={<Home/>} />
          <Route path='/privacy-policy' element={<PrivacyPolicy/>} />
          <Route path='/terms-of-use' element={<TermsOfUse/>} />
          {/* <Route path='/core-services' element={<CoreServices/>} /> */}
          {/* <Route path="*" element={<NotFound />} /> */}
        </Routes>

      

    </div>
  );
}

export default App;
